// src/constants/trendsBreakdownQueryIds.ts

export const TrendsBreakdownQueryIds = {
  COUNTRY: "5740688905863168",
  TRAFFIC_SOURCE: "5631821081477120",
  CAMPAIGN: "5177738952441856",
  AD_GROUP: "5731697752539136",
  KEYWORD_MATCH_TYPE: "5705076043677696",
  BRANDS: "5696630124707840",
};
export const TrendsDataSetQueryIds = {
  ACTION: "5722078678351872",
  CLICK: "5663297554612224",
};
export const TrendsFilterQueryIds = {
  CAMP: "5728744266268672",
  ADGROUP: "5658330156498944",
  KEYWORD: "5718746756808704",
};
